import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Animation, Button, Status } from '../../assets/global/globalStyles';
import MetaTitle from '../../components/MetaTitle';
import Table from '../../components/Table';
import useFetch from '../../hooks/useFetch';
import { fetchHistoryOrders } from '../../store/historyOrders';
import convertDate from '../../utils/convertDate';
import { getHistoryOrders } from '../../utils/httpRequest';
import { WAREHOUSE_GROUPS } from '../../global/variables/userGroups';

export default function HistoryOrders() {
  const {
    user: { data: user },
  } = useSelector((state) => state);
  const { data: historyOrders } = useFetch(
    fetchHistoryOrders(getHistoryOrders()),
    'historyOrders',
  );
  const navigate = useNavigate();

  const dataUpdateObject = React.useMemo(() => {
    const orderType = {
      AAA: 'Pedido Recebido',
      CBA: 'Pedido em Separação',
      CBB: 'Pedido em Conferência',
      CCC: 'Pedido em Trânsito',
      APP: 'Pedido Entregue',
    };
    return historyOrders.map((item) => ({
      ...item,
      deliveredDate:
        item.deliveredDate === '1900-01-01T00:00:00' ||
        item.deliveredDate === '0001-01-01T00:00:00'
          ? null
          : convertDate(item.deliveredDate),
      deliveryDate:
        item.deliveryDate === '1900-01-01T00:00:00' ||
        item.deliveryDate === '0001-01-01T00:00:00'
          ? null
          : convertDate(item.deliveryDate),
      _: orderType[item.orderStatus],
    }));
  }, [historyOrders]);

  const seeOrder = ({ warehouseId, document, orderStatus, licensePlate }) => {
    navigate(
      `/dashboard/orderstatus?document=${document}&warehouseId=${warehouseId}&orderStatus=${orderStatus}&licensePlate=${licensePlate}`,
    );
  };

  return (
    <Animation>
      <MetaTitle title="Histórico de Pedidos" />
      <Table
        data={dataUpdateObject}
        title="Gerenciamento de Histórico de Pedidos"
        keyStorage="historyorders_filter"
        columns={[
          'document',
          'warehouseCode',
          'warehouse',
          'deliveryDate',
          'deliveredDate',
          'orderStatus',
        ]}
        columnNames={[
          'Documento',
          user?.userGroup?.find(userGroup => WAREHOUSE_GROUPS.includes(userGroup))
            ? 'Depósito'
            : 'Centro de Destribuição',
          'Código Depósito',
          'Previsão de entrega',
          'Entrega realizada',
          'Status',
        ]}
        columnsModify={{
          orderStatus: (value) => {
            const orderType = {
              AAA: <Status typeName="warning">Pedido Recebido</Status>,
              CBA: <Status typeName="orange">Pedido em Separação</Status>,
              CBB: <Status typeName="danger">Pedido em Conferência</Status>,
              CCC: <Status typeName="welcome">Pedido em Trânsito</Status>,
              APP: <Status typeName="success">Pedido Entregue</Status>,
              default: value,
            };
            return orderType[value] || orderType['default'];
          },
          deliveryDate: (value) => (value === '01/01/1 00:00' ? '' : value),
          deliveredDate: (value) => (value === '01/01/1 00:00' ? '' : value),
        }}
        columnButtons={[
          (data) => (
            <Button typeName="welcome" onClick={() => seeOrder(data)}>
              Ver
            </Button>
          ),
        ]}
      />
    </Animation>
  );
}
